import * as React from "react"
import { StyleProp } from "react-native"
import { observer } from "mobx-react-lite"
import { Image, ImageStyle } from "../image/image"

const jalaLoading = require("./jala-loading.gif")

const LOADING_IMAGE = {
  width: 64,
  height: 64
}

export interface JalaLoadingProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ImageStyle>
}

/**
 * Describe your component here
 */
export const JalaLoading = observer(function JalaLoading(props: JalaLoadingProps) {
  const { style } = props
  const styles = Object.assign({}, LOADING_IMAGE, style)

  return (
    <Image source={jalaLoading} style={styles} />
  )
})
